import React from "react";


export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-black to-slate-950 text-slate-100 py-16 px-4 flex items-center justify-center">
      <div className="max-w-3xl w-full mx-auto bg-slate-900/80 rounded-3xl shadow-2xl border border-slate-800/60 p-8 md:p-12">
        <div className="flex flex-col items-center mb-10">
          <span className="text-emerald-400 text-5xl mb-2">&#128274;</span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-2 text-center">Politique de confidentialité</h1>
          <p className="text-base md:text-lg text-slate-400 text-center">Hiperyon s’engage à protéger vos données et votre vie privée.</p>
        </div>
        <div className="space-y-8">
          {[{
            title: "1. Éditeur du site",
            content: (
              <>
                <ul className="list-disc ml-6 mb-2">
                  <li>Ambroise Cainne – Auto-entrepreneur</li>
                  <li>Adresse : 7 boulevard de Maupou, France</li>
                  <li>E-mail : <a href="mailto:contact@hiperyon.com" className="text-emerald-400 hover:underline">contact@hiperyon.com</a></li>
                </ul>
                <p>Responsable de la publication : Ambroise Cainne</p>
              </>
            )
          }, {
            title: "2. Données collectées",
            content: (
              <ul className="list-disc ml-6">
                <li>Nom, e-mail, pseudo pour créer et gérer les comptes utilisateurs</li>
                <li>Données de navigation et cookies pour analyser le trafic et améliorer le service (via Google Analytics)</li>
                <li>Adresse IP pour des raisons de sécurité et de fonctionnement du site</li>
              </ul>
            )
          }, {
            title: "3. Finalité du traitement",
            content: (
              <ul className="list-disc ml-6">
                <li>Gérer les inscriptions et les comptes utilisateurs</li>
                <li>Fournir et améliorer les services du site Hiperyon</li>
                <li>Envoyer des communications liées au service</li>
                <li>Analyser l’usage du site pour optimiser l’expérience utilisateur</li>
              </ul>
            )
          }, {
            title: "4. Partage et accès aux données",
            content: (
              <p>Les données personnelles des utilisateurs ne sont pas vendues ni transmises à des tiers non autorisés, à l’exception de prestataires techniques nécessaires au fonctionnement du site (hébergeur, Google Analytics).</p>
            )
          }, {
            title: "5. Durée de conservation",
            content: (
              <>
                <p>Les données des utilisateurs sont conservées tant que leur compte est actif ou pour les besoins légaux et administratifs.</p>
                <p>Les cookies et données analytiques peuvent être conservés jusqu’à 13 mois selon les paramètres de Google Analytics.</p>
              </>
            )
          }, {
            title: "6. Droits des utilisateurs (RGPD)",
            content: (
              <>
                <ul className="list-disc ml-6">
                  <li>Accès à leurs données personnelles</li>
                  <li>Rectification ou mise à jour des informations</li>
                  <li>Suppression de leurs données</li>
                  <li>Opposition au traitement des données pour certaines finalités</li>
                </ul>
                <p>Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@hyperiome.com" className="text-emerald-400 hover:underline">contact@hyperiome.com</a></p>
              </>
            )
          }, {
            title: "7. Cookies",
            content: (
              <>
                <ul className="list-disc ml-6">
                  <li>Maintenir les sessions et la connexion des utilisateurs</li>
                  <li>Analyser le trafic et l’usage du site (Google Analytics)</li>
                  <li>Optimiser l’expérience utilisateur</li>
                </ul>
                <p>Vous pouvez gérer vos préférences cookies directement dans votre navigateur. Le refus de certains cookies peut limiter certaines fonctionnalités du site.</p>
              </>
            )
          }, {
            title: "8. Sécurité des données",
            content: (
              <p>Les données sont hébergées sur les serveurs sécurisés de Vercel Inc., garantissant la confidentialité et l’intégrité des informations. Des mesures techniques et organisationnelles sont mises en place pour protéger les données contre tout accès non autorisé, perte ou modification.</p>
            )
          }, {
            title: "9. Modifications de la politique",
            content: (
              <p>Hiperyon se réserve le droit de mettre à jour cette politique de confidentialité à tout moment. Les utilisateurs seront informés des changements significatifs sur le site ou par e-mail.</p>
            )
          }, {
            title: "10. Contact",
            content: (
              <p>Pour toute question sur la politique de confidentialité ou l’exercice de vos droits : <a href="mailto:contact@hyperiome.com" className="text-emerald-400 hover:underline">contact@hyperiome.com</a></p>
            )
          }].map((section, idx) => (
            <div key={section.title} className="bg-slate-900/70 rounded-xl border border-slate-800/40 p-6 mb-2 shadow">
              <h2 className="text-lg md:text-xl font-bold text-emerald-400 mb-3 flex items-center gap-2">
                <span className="text-emerald-400">{idx + 1}.</span> {section.title.replace(/^[0-9]+\. /, '')}
              </h2>
              <div className="text-slate-200 text-base md:text-lg leading-relaxed">
                {section.content}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
